export default __webpack_public_path__ + "static/media/llaves.3ef3e0a1.svg";